import { beginSignupFlow } from '@/src/contexts/signup-flow-state'
import { useResolvedAuthState } from '@/src/hooks/useResolvedAuthState'
import { queryKeys } from '@/src/queries/query-keys'
import { showAlert } from '@/src/utils/alert'
import { isIgnorableAuthSessionError } from '@/src/utils/auth-errors'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

export interface StartTrialVariables {
  firstName: string
}

export function useOnboardingSignInMutation(returnTo?: string | null) {
  const { authorize } = useResolvedAuthState()
  return useMutation({
    mutationKey: queryKeys.mutations.onboardingSignIn,
    mutationFn: async () => {
      await authorize({
        screen_hint: 'login',
        prompt: 'login',
        returnTo: returnTo ?? undefined,
      })
    },
  })
}

export function useOnboardingStartTrialMutation(returnTo?: string | null) {
  const { authorize } = useResolvedAuthState()
  const { t } = useTranslation(['common', 'setup'])

  return useMutation({
    mutationKey: queryKeys.mutations.onboardingStartTrial,
    mutationFn: async ({ firstName }: StartTrialVariables) => {
      await beginSignupFlow({
        firstName,
      })
      await authorize({
        screen_hint: 'signup',
        prompt: 'login',
        returnTo: returnTo ?? undefined,
      })
    },
    onError: (error) => {
      if (isIgnorableAuthSessionError(error)) {
        return
      }

      showAlert(t('common:error'), t('setup:error_generic'))
    },
  })
}
